import gql from 'graphql-tag';

export const GET_CME_EVENTS_RECORD = gql`
  query getCMEEventsRecord($id: uuid!, $doctor_id: uuid!) {
    record: hkdutest_cme_events_by_pk(id: $id) {
      id
      name
      start_time
      end_time
      price
      member_price
      date
      content
      score
      location
      unenrollable
      speaker
      doctors(where: { doctor_id: { _eq: $doctor_id } }) {
        doctor {
          id
        }
      }
      organizer {
        id
        name
      }
      tags {
        tag {
          name
        }
      }
    }
  }
`;

export const GET_E_DRUG_EVENTS_RECORD = gql`
  query getEDrugEventsRecord($id: uuid!, $doctor_id: uuid!) {
    record: hkdutest_e_drug_events_by_pk(id: $id) {
      id
      name
      start_time
      end_time
      price
      member_price
      date
      content
      location
      speaker
      unenrollable
      doctors(where: { doctor_id: { _eq: $doctor_id } }) {
        doctor {
          id
        }
      }
      organizer {
        id
        name
      }
      tags {
        tag {
          name
        }
      }
    }
  }
`;

export const GET_HKDU_EVENTS_RECORD = gql`
  query getMemberOnlyHKDUEventsRecord($id: uuid!, $doctor_id: uuid!) {
    record: hkdutest_hkdu_events_by_pk(id: $id) {
      id
      name
      start_time
      end_time
      price
      member_price
      date
      content
      location
      speaker
      unenrollable
      doctors(where: { doctor_id: { _eq: $doctor_id } }) {
        doctor {
          id
        }
      }
      tags {
        tag {
          name
        }
      }
    }
  }
`;
